import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { DEAUTH_USER } from '@app/constants/actions';
import type { FilterProperties } from '@app/types/case-filters';
import { CaseTypeEnum } from '@app/types/create-case';

export type CaseTypeFiltersState = Partial<
  Record<CaseTypeEnum, FilterProperties>
>;

const initialState: CaseTypeFiltersState = {};

export const caseTypeFiltersSlice = createSlice({
  name: 'caseTypeFilters',
  initialState,
  reducers: {
    setCaseTypeFilters: (
      state,
      action: PayloadAction<{
        caseType: CaseTypeEnum;
        filters: FilterProperties;
      }>,
    ) => {
      const { caseType, filters } = action.payload;
      state[caseType] = { ...state[caseType], ...filters };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(DEAUTH_USER, () => initialState);
  },
});

export const { setCaseTypeFilters } = caseTypeFiltersSlice.actions;
